import React from 'react';

export const Button = ({ 
  children, 
  variant = 'primary', 
  className = '', 
  as: Component = 'button',
  ...props 
}) => {
  const baseStyle = "px-4 py-2 rounded-md font-medium text-sm transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    primary: "bg-primary hover:bg-primary-hover text-white shadow-lg shadow-primary/20",
    secondary: "bg-base-700 hover:bg-base-600 text-white border border-base-600",
    accent: "bg-accent hover:bg-accent-hover text-base-900 font-semibold shadow-lg shadow-accent/20",
    danger: "bg-red-500/10 hover:bg-red-500/20 text-red-500 border border-red-500/20",
    ghost: "hover:bg-base-700 text-gray-400 hover:text-white"
  };

  return (
    <Component 
      className={`${baseStyle} ${variants[variant]} ${className}`} 
      {...props}
    >
      {children}
    </Component>
  );
};